<cap-content-header>
  <cap-title>
    {{ "batchauftrag.detail.Titel" | translate }}
    {{ "datenexport." + auftragEntry.batchAuftragListEntry.datenexportAuftragTyp | translate }}
  </cap-title>
</cap-content-header>

<div class="row">
  <div class="col-md-12 col-12">
    <cap-auftrag-kopfdaten [auftragEntry]="auftragEntry"></cap-auftrag-kopfdaten>
    @if (auftragEntry.auftragExceptions.length > 0) {
      <cap-rubrik [id]="'fehlermeldung'" [isClosable]="true" [isOpen]="true">
        <ng-container title>
          <h3>{{ "Fehlermeldungen" | translate }}</h3>
        </ng-container>
        @for (ex of auftragEntry.auftragExceptions; track ex) {
          <textarea
            [ngModel]="ex"
            class="textarea-detail col-md-12 mx-0 mb-0 mt-1"
            name="exceptions"
            readonly
            style="height: 8em; resize: none">
          </textarea>
        }
      </cap-rubrik>
    }
    <cap-rubrik [isOpen]="true">
      <ng-container title>
        <h3>{{ "Auftrag" | translate }}</h3>
      </ng-container>
      <div class="mt-2 border">
        <div class="m-4">
          <!-- prettier-ignore -->
          <cap-auftrag-new [readonly]="true" [auftrag]="auftragEntry"></cap-auftrag-new>
        </div>
      </div>
    </cap-rubrik>
  </div>
</div>
